import { useTranslation } from "react-i18next";

export const useTranslateData = () => {
  const { t } = useTranslation();
  return [
    {
      id: "city",
      key: t("widgetTable.address"),
      value: "-",
    },
    {
      id: "countryCode",
      key: t("widgetTable.countryCode"),
      value: "-",
    },
    {
      id: "ip",
      key: t("widgetTable.myIp"),
      value: "-",
    },
    {
      id: "host",
      key: t("widgetTable.host"),
      value: "-",
    },
    {
      id: "provider",
      key: t("widgetTable.provider"),
      value: "-",
    },
    {
      id: "country",
      key: t("widgetTable.country"),
      value: "-",
    },
    {
      id: "city",
      key: t("widgetTable.city"),
      value: "-",
    },
    {
      id: "zipcode",
      key: t("widgetTable.zipCode"),
      value: "-",
    },
    {
      id: "coordinates",
      key: t("widgetTable.coordinates"),
      value: "-",
    },
  ];
};
